/* eslint-disable no-useless-escape */
import axios from 'axios'
import { message } from 'antd'
import { TOKEN_KEY } from 'service/config'
import { beforeLogout } from 'stores/commons/BeforeLogout'
import { execSign } from 'utils/encode'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API, // common 的 base_url
  timeout: 15000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(
  (config) => {
    if (sessionStorage.getItem(TOKEN_KEY)) {
      config.headers['token'] = sessionStorage.getItem(TOKEN_KEY)
    }
    const { ts, nonce, sign } = execSign(config?.data)
    config.headers['ts'] = ts
    config.headers['nonce'] = nonce
    config.headers['sign'] = sign
    return config
  },
  (error) => {
    Promise.reject(error)
  }
)

service.interceptors.response.use(
  (response) => {
    const { data, config, headers } = response
    // 下载文件流
    if (config.responseType === 'blob') {
      console.log('data', data, data.type)
      if (data.type !== 'application/json') {
        return { blob: data, headers, type: data.type }
      } else if (data.type === 'application/json') {
        return new Promise((resolve) => {
          let reader = new FileReader()
          reader.onload = (e) => {
            if (e.target.readyState === 2) {
              let result = {}
              result = JSON.parse(e.target.result)
              resolve({
                ...result,
                type: data.type
              })
            }
          }
          reader.readAsText(data)
        })
      }
    }

    const res = response.data
    // eslint-disable-next-line no-useless-escape
    let reg = /^\/\-+/
    const noCodeInterfaceUrlList = [
      '/common/enums',
      '/doc/batch/download',
      '/doc/log/page',
      '/doc/log/detail/list'
    ] // 接口返回没有code的url列表
    if (
      reg.test(response.config.url) ||
      noCodeInterfaceUrlList.some(
        (item) => response.config.url.indexOf(item) > -1
      )
    ) {
      return response.data
    }
    if (
      Number(res.code) === 0 ||
      Number(res.code) === 200 ||
      Number(res.repCode) === 0
    ) {
      return response.data
    } else if (res.code > 400 && res.code < 404) {
      message.error(res.msg || res.message)
      console.log('999')
      //登录过期
      beforeLogout()
      return
    } else if (res.code === 404) {
      message.error('接口未找到')
    } else {
      message.error(res.msg || res.message || '请求错误')
      return res
    }
  },
  (error) => {
    console.log('eeeee', error.response)
    if (error.response) {
      let obj = error.response
      console.log('999', obj, obj.status, obj.config.url)
      if (obj.config.url.indexOf('/check') > -1) {
        return obj.data
      }
      if (obj.status > 400 && obj.status < 404) {
        message.warning('您的登录已过期，请重新登录')
        console.log('888')
        beforeLogout()
      } else if (obj.status === 404) {
        message.error('接口未找到')
      } else {
        message.error(
          obj.message ||
            obj?.data?.message ||
            obj?.data?.errorMessage ||
            '服务异常'
        )
      }
      return error.response
    } else {
      message.error(error.message || '服务异常')
      return error.response
    }
  }
)

const get = (url, params = {}) => {
  return service({
    url: url,
    method: 'get',
    params
  }).then((rs) => {
    return rs
  })
}

const post = (url, data = {}) => {
  return service({
    url: url,
    method: 'post',
    data
  }).then(
    (rs) => {
      return rs
    },
    (rj) => {
      return rj
    }
  )
}
const postDataQuery = (url, params = {}, data, config = {}) => {
  return service({
    url: url,
    timeout: 100000 * 15000,
    method: 'post',
    params,
    data,
    ...config
  }).then(
    (rs) => {
      return rs
    },
    (rj) => {
      return rj
    }
  )
}
const put = (url, params = {}) => {
  return service({
    url: url,
    method: 'put',
    params
  }).then(
    (rs) => {
      return rs
    },
    (rj) => {
      return rj
    }
  )
}
const _put = (url, data = {}) => {
  return service({
    url: url,
    method: 'put',
    data
  }).then(
    (rs) => {
      return rs
    },
    (rj) => {
      return rj
    }
  )
}

const del = (url, data = {}) => {
  return service({
    url: url,
    method: 'delete',
    data
  }).then((rs) => {
    return rs
  })
}

const _del = (url, params = {}) => {
  return service({
    url: url,
    method: 'delete',
    params
  }).then((rs) => {
    return rs
  })
}

const patch = (url, data = {}) => {
  return service({
    url: url,
    method: 'patch',
    data
  }).then((rs) => {
    return rs
  })
}

const postQuery = (url, params = {}) => {
  return service({
    url: url,
    method: 'post',
    params
  }).then(
    (rs) => {
      return rs
    },
    (rj) => {
      return rj
    }
  )
}

const _post = (url, config = {}, conf = {}) => {
  const _url = url
  const {
    cancelToken,
    ContentType,
    noThrow,
    params,
    _Pdata,
    formData,
    responseType,
    hasParams,
    ..._data
  } = config
  const { isCustomException = false } = conf
  let curPostData = _Pdata || _data
  if (Array.isArray(config)) {
    curPostData = config
  }
  if (ContentType && ContentType === 'text/plain') {
    curPostData = _data.data
  } else if (formData) {
    curPostData = formData
  }
  if (hasParams) {
    curPostData.params = params
  }
  const _config = {}
  const postConfig = {
    url: _url,
    data: curPostData,
    method: 'POST',
    params: !hasParams ? params : undefined,
    responseType,
    ..._config,
    noThrow,
    isCustomException,
    headers: {
      // token: getToken(),
      ...(ContentType && { 'Content-Type': ContentType })
    }
  }

  return service(postConfig)
}

const downLoadFile = (url, data, method = 'post', config = {}, params) => {
  return axios({
    // baseURL: baseurl,
    url: url,
    method: method,
    data: data,
    params: params,
    headers: {
      token: sessionStorage.getItem(TOKEN_KEY),
      'content-type': 'application/json; charset=utf-8'
    },
    responseType: 'blob',
    processData: false, // 告诉axios不要去处理发送的数据(重要参数)
    contentType: false, // 告诉axios不要去设置Content-Type请求头
    ...config
  })
    .then((res) => {
      return res.data
    })
    .catch((error) => {
      try {
        if (error.response.data.status === 500) {
          message.error('系统异常')
          return Promise.reject(error)
        } else {
          return error.response.data
        }
      } catch {
        message.error('系统异常')
        return Promise.reject(error)
      }
    })
}

/**
 * 上传媒体资源
 * @param {*} url 请求地址
 * @param {*} data 请求参数
 */
const postMediaFormData = (url, data, method = 'post', config = {}) => {
  return service({
    url: url,
    method,
    timeout: 100000 * 15000,
    data: method === 'post' ? data : {},
    params: method === 'get' ? data : undefined,
    headers: {
      token: sessionStorage.getItem(TOKEN_KEY)
    },
    processData: false, // 告诉axios不要去处理发送的数据(重要参数)
    contentType: false, // 告诉axios不要去设置Content-Type请求头
    // cancelToken: getCancelToken(url, {}, 'post')['token'],
    ...config
  })
    .then((res) => {
      if (res) {
        return res
      }
    })
    .catch((error) => {
      console.log(error)
      try {
        if (error.response.data.status === 500) {
          // message.warning('系统异常')
          return Promise.reject(error)
        } else {
          return error.response.data
        }
      } catch {
        if (axios.isCancel(error)) {
          console.log('Rquest canceled', error.message) //请求如果被取消，这里是返回取消的message
          return Promise.reject(error)
        } else {
          // message.warning('系统异常')
          return Promise.reject(error)
        }
      }
    })
}

//以上方法用于临时联调履职用--开始
export {
  get,
  post,
  put,
  del,
  _del,
  patch,
  _post,
  _put,
  service,
  postQuery,
  postDataQuery,
  downLoadFile,
  postMediaFormData
}
export default service
